import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from "react";
var ColorLabel = /*#__PURE__*/function (_Component) {
  function ColorLabel() {
    _classCallCheck(this, ColorLabel);
    return _callSuper(this, ColorLabel, arguments);
  }
  _inherits(ColorLabel, _Component);
  return _createClass(ColorLabel, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        color = _this$props.color,
        tooltip = _this$props.tooltip;
      return /*#__PURE__*/React.createElement("div", {
        className: "dot",
        key: this.props.key
      }, /*#__PURE__*/React.createElement("div", {
        className: "dot-content",
        style: {
          backgroundColor: color
        },
        "data-tooltip": tooltip
      }), /*#__PURE__*/React.createElement("span", {
        className: "text"
      }, tooltip));
    }
  }]);
}(Component);
export default ColorLabel;